module.exports = __webpack_public_path__ + "img/web_03.f776278d.png";